module.exports = __webpack_public_path__ + "static/media/step3_m.92cdc932.png";